jQuery(document).ready(function ($) {
    // 	Hide/Show attic
    $(window).on('scroll', function(){
        var scrollTop = $(window).scrollTop();
        var heroH = $('.hero').outerHeight();
        if(scrollTop >= heroH) {
            $('.sales-page__header').addClass('sales-page__header--show');
        } else {
            $('.sales-page__header').removeClass('sales-page__header--show');
        }
    });


    // Topics covered tooltips
    // new jBox('Tooltip', {
    //     attach: '.view-list',
    //     adjustPosition: true,
    //     trigger: 'click',
    //     addClass: 'tooltip-definition',
    //     zIndex: 9,
    //     content: $('.jbox-content'),
    //     //closeButton: true,
    //     closeButton: false,
    //     closeOnClick: true,
    //     position: {
    //         x: 'center',
    //         y: 'bottom'
    //     },
    //     offset: {
    //         y: 0
    //     },
    //     onOpen: function () {
    //         //console.log('OPENED');
    //         var id = this.source.attr('data-jbox-content');
    //         console.log('OPENED' + id);
    //         this.content.find('.jbox-content').css({display: 'none'});
    //         this.content.find('.jbox-content-' + id).css({display: 'block'});
    //     }
    // });

    new jBox('Tooltip', {
        attach: '.tooltip',
        adjustPosition: true,
        zIndex: 9,
        addClass: 'tooltip-info',
        position: {
            x: 'center',
            y: 'bottom'
        },
        closeButton: true,
        closeOnClick: true,
        trigger: 'click',
        getTitle: 'data-title',
        getContent: 'data-content'
    });

    let studentFormValues = null;
    $('body').on('click','.student-discount-button',function(e){
        e.preventDefault();
        $('#form-errors').html();
        $("#form-errors").css('display', 'none');

        const formValues = $('#student-discount-form :input[type="text"]');
        var values = {};
        var formHasMissingValue = false;
        formValues.each(function() {
            if(!$(this).val() && this.type !== 'submit' && this.type !== 'checkbox') {
                formHasMissingValue = true;
            }
        });
        if($('#student-discount-form').find('input[type="checkbox"]').prop('checked') !== true) {
            formHasMissingValue = true;
        }
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(formHasMissingValue) {
            $('#form-errors').html('All fields required.');
            $("#form-errors").css('display', 'block');
            return false;
        } else if(!regex.test($('#student-discount-form :input[name="mm_field_email"]').val())) {
            $('#form-errors').html('Please enter a valid email address.');
            $("#form-errors").css('display', 'block');
            return false;
        } else {
            document.body.style.overflow = "hidden";
            e.preventDefault();
            studentFormValues = formValues;
            let product = $(this).attr('data-product');
            let overlay = $(this).attr('data-overlay');
            let discountValue = $(this).attr('data-discount-value');
            let conversion = $(this).attr('data-conversion');
            if(!product || !overlay){
                console.log('product or overlay missing 1');
            }
            showPurchaseOverlay(overlay,product, null);
        }
    });

    $('body').on('click','.continue-button',function(){
        document.body.style.overflow = "scroll";
        let parentOverlay = $(this).closest('.overlay');
        parentOverlay.find('input').each(function(){$(this).val('')});
        parentOverlay.hide();
    });


    $('body').on('click', '.buy-now', function(e){
        if($(this).hasClass('not-upgradeable') || $(this).hasClass('not-upgradeable-plus')){
            e.preventDefault();
            return;
        }
        // document.body.style.overflow = "hidden";
        e.preventDefault();
       let product = $(this).attr('data-product');
       let overlay = $(this).attr('data-overlay');
       let discountValue = $(this).attr('data-discount-value');
       let discountPercentage = $(this).attr('data-discount-percentage');
       let webinar = $(this).attr('data-webinar');
       let conversion = $(this).attr('data-conversion');
       let formtype = $(this).attr('data-type');

       let secondaryProduct = $(this).attr('data-secondary-product');


       if(!overlay || !product){
           console.log('product or overlay missing');
       }
       showPurchaseOverlay(overlay,product, secondaryProduct, discountValue, discountPercentage, webinar, conversion, formtype, this, studentFormValues);
    });

    // $('body').on('click', '.trigger-modal', function(e){
    //     console.log('trigger modal triggered');
    //     // document.body.style.overflow = "hidden";
    //     e.preventDefault();
    //     let product = $(this).attr('data-product');
    //     let overlay = $(this).attr('data-overlay');
    //     let discountValue = $(this).attr('data-discount-value');
    //     if(!product || !overlay){
    //         console.log('product or overlay missing');
    //     }
    //     showPurchaseOverlay(overlay,product, discountValue, this);
    // });

    $('body').on('click', '.popup-trigger-modal', function(e){
        e.preventDefault();
        let overlay = $(this).data('overlay');
        if(overlay){
            localStorage.setItem('showModalDetails', JSON.stringify({ overlay }));
            window.location.href = $(this).attr('href');
        } else {
            console.log('overlay missing');
        }
    });

    let showModalDetails = localStorage.getItem('showModalDetails');
    let modalAlreadyShown = localStorage.getItem('modalShown');

    if (showModalDetails && !modalAlreadyShown) {
        showModalDetails = JSON.parse(showModalDetails);
        showPopupOverlay(showModalDetails.overlay);
        localStorage.setItem('modalShown', 'true');
        localStorage.removeItem('showModalDetails');
    }

    function showPopupOverlay(overlayTemplate)
    {
        $('.overlay--checkout').remove();
        let postData = {
            overlay_template:overlayTemplate,
        };

        $.post(accountingcoach.ajax_url +'?action=ac_get_popup_overlay',postData).then(function(res){
            $('body').append(res)
            new jBox('Tooltip', {
                attach: '.security-code-icon',
                adjustPosition: true,
                trigger: 'click',
                addClass: 'tooltip-definition',
                zIndex: 9999,
                content: $('.security-code-tooltip'),
                closeButton: true,
                closeOnClick: true,
                position: {
                    x: 'center',
                    y: 'bottom'
                },
                offset: {
                    y: 0
                },
                onOpen: function () {
                    this.content.find('.security-code-tooltip').css({display: 'block'});
                }
            });

            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            $('body > header .attic').css('padding-right', scrollbarWidth + 20 + 'px');
            document.body.style.overflow = "hidden";
        }).catch(function(e){
            console.log(e);
        })
    }

    let expressCheckoutElement = null;

    function cleanUpStripeElements() {
        if (expressCheckoutElement) {
            expressCheckoutElement.destroy();
            expressCheckoutElement = null;
        }
    }

    let exitModalShown = false;
    function showPurchaseOverlay(overlayTemplate,productId, secondaryProduct, discountValue, discountPercentage, webinar = null, conversion = null, formtype = null, parentButton = null, appendFormValues = null, secondaryProductId = null)
    {
        $('.overlay--checkout').remove();
        let postData = {
            overlay_template:overlayTemplate,
            product_id:productId,
        };

        if (secondaryProduct) {
            postData.secondary_product_id = secondaryProduct
        }

        if (discountValue) {
            postData.discount_value = discountValue;
        }

         if (discountPercentage) {
            postData.discount_percentage = discountPercentage;
        }

        if (webinar) {
            postData.webinar = webinar;
        }

        if (conversion) {
            postData.conversion = conversion;
        }
        if (formtype) {
            postData.type = formtype;
        }

        $.post(accountingcoach.ajax_url +'?action=ac_get_purchase_overlay',postData).then(function(res){
            $('body').append(res)
            new jBox('Tooltip', {
                attach: '.security-code-icon',
                adjustPosition: true,
                trigger: 'click',
                addClass: 'tooltip-definition',
                zIndex: 9999,
                content: $('.security-code-tooltip'),
                closeButton: true,
                closeOnClick: true,
                position: {
                    x: 'center',
                    y: 'bottom'
                },
                offset: {
                    y: 0
                },
                onOpen: function () {
                    this.content.find('.security-code-tooltip').css({display: 'block'});
                }
            });

            const price = $(parentButton).attr('data-total-price');
            const quantity = $(parentButton).attr('data-quantity');
            const adminquantity = $(parentButton).attr('data-adminquantity');
            const userquantity = $(parentButton).attr('data-userquantity');
            if(price) {
                $('.order-total').html(price);
            }
            if(adminquantity) {
                $('.admin-quantity').html(adminquantity);
                $('input[name="admin-quantity"]').val(adminquantity);
                if(adminquantity > 1) {
                    $('.account').html('accounts');
                }
            }

            if(userquantity) {
                $('.user-quantity').html(userquantity);
                $('input[name="user-quantity"]').val(userquantity);
                if(userquantity > 1) {
                    $('.account').html('accounts');
                }
            }

            if(quantity) {
                $('.bulk-quantity').html(quantity);
                $('input[name="account-quantity"]').val(quantity);
                if(quantity > 1) {
                    $('.account').html('accounts');
                }
            }

            if(appendFormValues) {
                appendFormValues.each(function() {
                    $('<input>').attr('type','hidden').attr('name','student_'+this.name).val($(this).val()).appendTo('#payment-form');
                    if (this.name === 'mm_field_email') {
                        $('#payment-form #mm_field_email').val($(this).val());
                    }
                });
            }

            if (!exitModalShown && $(parentButton).attr('data-overlay-onclose') && $(parentButton).attr('data-product-onclose')) {
                if (!getCookie('exitIntentShown')) {
                    setCookie('exitIntentShown', 'true', 365);
                    // Code to show the exit intent overlay
                    $('.close-button').addClass('buy-now');
                    $('.close-button').attr('data-overlay', $(parentButton).attr('data-overlay-onclose'));
                    $('.close-button').attr('data-product', $(parentButton).attr('data-product-onclose'));
                }
                exitModalShown = true;
            }

            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            $('body > header .attic').css('padding-right', scrollbarWidth + 20 + 'px');
            document.body.style.overflow = "hidden";

            cleanUpStripeElements();
            console.log('setting up stripe elements..');
            setupStripeElements();


        }).catch(function(e){
            console.log(e);
        })

    }

    $('body').on('click','.close-button',function(){
        document.body.style.overflow = "scroll";
        $('body > header .attic').css('padding-right', '20px');
       let parentOverlay = $(this).closest('.overlay');
       parentOverlay.find('input').each(function(){$(this).val('')});
       parentOverlay.hide();
       console.log('close button clicked');
       cleanUpStripeElements();
       // if (window.stripe) {
       //     console.log('express element exists');
       //     expressCheckoutElement.destroy();
       // } else {
       //     console.log('no express element');
       // }
    });

    $('body').on('change', 'input[name="creditorpaypal"]', function(){
        if($(this).val() === 'paypal' || $(this).val() === 'applepay' || $(this).val() === 'amazonpay') {
            $('.payment-details').hide();
        } else {
            $('.payment-details').show();
        }
    });

    // checkout-form-verify=5253bb48a7&_wp_http_referer=%2Fwp-admin%2Fadmin-ajax.php%3Faction%3Dac_get_purchase_overlay&mm_field_email=dfkjdfdfkjdf%40stream9.net&mm_field_password=testuser289&creditorpaypal=credit&mm_field_cc_number=4111111111111111&mm_field_cc_exp_month=08&mm_field_cc_exp_year=2031&mm_field_cc_cvv=282&total=99&productId=383
    function parseSerializedData(serialized) {
        const params = new URLSearchParams(serialized);
        return {
            product_id: params.get('productId'),
            payment_type: params.get('creditorpaypal'),
            price: parseFloat(params.get('total')),
            quantity: params.get('account-quantity')
        };
    }

    let productNameMap = {
        '115835': 'PRO Plus newsletter',
        '114130': 'PRO Plus Webinar Small Business Owner (Bookkeeping) - B',
        '114129': 'PRO Plus Webinar Small Business Owner (Bookkeeping) - A',
        '114128': 'PRO Plus Webinar Small Business Owner (Accounting) - B',
        '114127': 'PRO Plus Webinar Small Business Owner (Accounting) - A',
        '114126': 'PRO Plus Webinar Students (Bookkeeping) - B',
        '114125': 'PRO Plus Webinar Students (Bookkeeping) - A',
        '114123': 'PRO Plus Webinar Students (Accounting) - B',
        '114122': 'PRO Plus Webinar Students (Accounting) - A',
        '114121': 'PRO Plus Webinar Unemployed (Bookkeeping) - B',
        '114120': 'PRO Plus Webinar Unemployed (Bookkeeping) - A',
        '114115': 'PRO Plus Webinar Employee Advanced (Bookkeeping) - B',
        '114114': 'PRO Plus Webinar Employee Advanced (Bookkeeping) - A',
        '114113': 'PRO Plus Webinar Unemployed (Accounting) - B',
        '114112': 'PRO Plus Webinar Unemployed (Accounting) - A',
        '114111': 'PRO Plus Webinar Employee Beginner (Bookkeeping) - B',
        '114110': 'PRO Plus Webinar Employee Beginner (Bookkeeping) - A',
        '114109': 'PRO Plus Webinar Employee Advanced (Accounting) - B',
        '114106': 'PRO Plus Webinar Employee Advanced (Accounting) - A',
        '113983': 'PRO Plus Membership Student',
        '113981': 'PRO Membership Student',
        '394': 'PRO Plus Webinar Employee Beginner (Accounting) - B',
        '393': 'PRO Plus Webinar Employee Beginner (Accounting) - A',
        '388': 'PRO Plus Membership Discount',
        '387': 'PRO Plus Membership',
        '386': 'PRO Plus Membership Upgrade Discount',
        '385': 'PRO Plus Membership Upgrade',
        '384': 'PRO Membership Discount',
        '383': 'PRO Membership',
        '116889': 'PRO Plus Membership HelpScout',
        '118336': 'PRO Plus Membership Newsletter Anniversary',
        '116893': 'PRO Plus Membership Newsletter Cheat Sheet',
        '116892': 'PRO Plus Membership Newsletter Webinar',
        '116923': 'PRO Plus Membership PPC'

    };

    let bulkPricingMap = {
        '383': 79,
        '387': 139
    }


    // Create a token when the form is submitted.
    $(document).on('click', '.button.purchase', function(e) {
        e.preventDefault();
        $("#card-errors").html();
        $("#card-errors").css('display', 'none');

        const formValues = $('#payment-form :input');
        var values = {};
        formValues.each(function() {
            if($(this).attr('type') === 'radio' && !this.checked) {
                return;
            }
            values[this.name] = $(this).val();
        });

        if(!values) {
            $("#card-errors").html('Something went wrong');
            $("#card-errors").css('display', 'block');
            return;
        }
        if(!values['mm_field_email'] || !values['mm_field_password']) {
            $("#card-errors").html('Please fill out all required fields');
            $("#card-errors").css('display', 'block');
            return;
        }

        if (values['creditorpaypal'] === 'amazonpay') {
            startAmazonPaySession(values);
            return;
        }

        if(values['creditorpaypal'] === 'credit') {
            if(!values['mm_field_cc_number'] || !values['mm_field_cc_exp_year'] || !values['mm_field_cc_exp_month'] || !values['mm_field_cc_cvv']) {
                $("#card-errors").html('Please include all card details');
                $("#card-errors").css('display', 'block');
                return;
            }
        }
        $(this).prop('disabled', true);
        $(this).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');


        var thisCopy = this;

        grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
            $.post(accountingcoach.ajax_url + '?action=ac_purchase_membership',
                $('#payment-form').serialize() + '&token=' + token,
            ).then(function (res) {
                if (res.status === 'paypal-redirect') {
                    window.location.replace(res.url);
                } else {
                    let productData = parseSerializedData($('#payment-form').serialize());
                    let productName = productNameMap[productData.product_id]
                    if (typeof zaraz !== 'undefined' && zaraz.ecommerce) {
                        zaraz.ecommerce('Order Completed', {
                            product_id: productData.product_id,
                            price: productData.price,
                            payment_type: productData.payment_type,
                            name: productName,
                            currency: 'USD',
                        }).then(function () {
                            window.location.href = accountingcoach.site_url + '/purchase-survey/';
                            getUpdatedAchievementPopup();
                        }).catch(function (error) {
                            console.error('E-commerce tracking failed', error);
                            window.location.href = accountingcoach.site_url + '/purchase-survey/';
                            getUpdatedAchievementPopup();
                        });
                    } else {
                        console.error('Zaraz is not defined or ecommerce method is not available');
                        window.location.href = accountingcoach.site_url + '/purchase-survey/';
                        getUpdatedAchievementPopup();
                    }
                }
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
            }).catch(function (e) {
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
                $("#card-errors").html(e.responseJSON.message);
                $("#card-errors").css('display', 'block');
                console.log(e);
            });
        })

    });

    let amazonUpgrade = false;

    $(document).on('click', '.button.upgrade', function(e) {
        e.preventDefault();
        $("#card-errors").html();
        $("#card-errors").css('display', 'none');

        const formValues = $('#payment-form :input');
        var values = {};
        formValues.each(function() {
            if($(this).attr('type') === 'radio' && !this.checked) {
                return;
            }
            values[this.name] = $(this).val();
        });

        if(!values) {
            $("#card-errors").html('Something went wrong');
            $("#card-errors").css('display', 'block');
            return;
        }

        if (values['creditorpaypal'] === 'amazonpay') {
            amazonUpgrade = true;
            startAmazonPaySession(values);
            return;
        }

        if(values['creditorpaypal'] === 'credit' || values['creditorpaypal'] === 'applepay') {
            if(!values['mm_field_cc_number'] || !values['mm_field_cc_exp_year'] || !values['mm_field_cc_exp_month'] || !values['mm_field_cc_cvv']) {
                $("#card-errors").html('Please include all card details');
                $("#card-errors").css('display', 'block');
                return;
            }
        }
        $(this).prop('disabled', true);
        $(this).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');


        var thisCopy = this;

        grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
            $.post(accountingcoach.ajax_url + '?action=ac_upgrade_membership',
                $('#payment-form').serialize() + '&token=' + token,
            ).then(function (res) {
                if (res.status === 'paypal-redirect') {
                    window.location.replace(res.url);
                } else {
                    let productData = parseSerializedData($('#payment-form').serialize());
                    let productName = productNameMap[productData.product_id]
                    if (typeof zaraz !== 'undefined' && zaraz.ecommerce) {
                        zaraz.ecommerce('Order Completed', {
                            product_id: productData.product_id,
                            price: productData.price,
                            payment_type: productData.payment_type,
                            name: productName,
                            currency: 'USD',
                        }).then(function () {
                            window.location.href = accountingcoach.site_url + '/welcome/?upgrade=true';
                            getUpdatedAchievementPopup();
                        }).catch(function (error) {
                            console.error('E-commerce tracking failed', error);
                            window.location.href = accountingcoach.site_url + '/welcome/?upgrade=true';
                            getUpdatedAchievementPopup();
                        });
                    } else {
                        console.error('Zaraz is not defined or ecommerce method is not available');
                        window.location.href = accountingcoach.site_url + '/welcome/?upgrade=true';
                        getUpdatedAchievementPopup();
                    }

                }
            }).catch(function (e) {
                $("#card-errors").html(e.responseJSON.message);
                $("#card-errors").css('display', 'block');
                console.log(e);
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
            });
        });

    });

    $(document).on('click', '.button.bulk-purchase', function(e) {
        e.preventDefault();
        $("#card-errors").html();
        $("#card-errors").css('display', 'none');

        const formValues = $('#payment-form :input');
        var values = {};
        formValues.each(function() {
            if($(this).attr('type') === 'radio' && !this.checked) {
                return;
            }
            values[this.name] = $(this).val();
        });

        if(!values) {
            $("#card-errors").html('Something went wrong');
            $("#card-errors").css('display', 'block');
            return;
        }
        if(!values['mm_field_email']) {
            $("#card-errors").html('Please fill out all required fields');
            $("#card-errors").css('display', 'block');
            return;
        }

        if (values['creditorpaypal'] === 'amazonpay') {
            startAmazonPaySession(values);
            return;
        }

        if(values['creditorpaypal'] === 'credit' || values['creditorpaypal'] === 'applepay') {
            if(!values['mm_field_cc_number'] || !values['mm_field_cc_exp_year'] || !values['mm_field_cc_exp_month'] || !values['mm_field_cc_cvv']) {
                $("#card-errors").html('Please include all card details');
                $("#card-errors").css('display', 'block');
                return;
            }
        }
        $(this).prop('disabled', true);
        $(this).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');


        var thisCopy = this;

        grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
            $.post(accountingcoach.ajax_url + '?action=ac_bulk_order',
                $('#payment-form').serialize() + '&token=' + token,
            ).then(function (res) {
                if (res.status === 'paypal-redirect') {
                    window.location.replace(res.url);
                } else {
                    window.location.href = accountingcoach.site_url + '/teams-purchase-survey';
                    getUpdatedAchievementPopup();

                    //TODO: Zaraz stuff. Redo this part to include the team product types (admin and member) and
                    // combine it into one

                    // let productData = parseSerializedData($('#payment-form').serialize());
                    // console.log($('#payment-form').serialize());
                    // let productName = productNameMap[productData.product_id]
                    // let productPrice = bulkPricingMap[productData.product_id];
                    // if (typeof zaraz !== 'undefined' && zaraz.ecommerce) {
                    //     zaraz.ecommerce('Order Completed', {
                    //         product_id: productData.product_id,
                    //         price: productPrice * productData.quantity,
                    //         payment_type: productData.payment_type,
                    //         name: productName + ' ' + 'Bulk Order ' + '(' + productData.quantity + ')',
                    //         currency: 'USD',
                    //     }).then(function () {
                    //         $('#payment-successful').html('Order complete! We will contact you at the email provide to create the accounts.')
                    //         $("#payment-successful").css('display', 'block');
                    //         $(thisCopy).hide();
                    //     }).catch(function (error) {
                    //         $('#payment-successful').html('Order complete! We will contact you at the email provide to create the accounts.')
                    //         $("#payment-successful").css('display', 'block');
                    //         $(thisCopy).hide();
                    //     });
                    // } else {
                    //     $('#payment-successful').html('Order complete! We will contact you at the email provide to create the accounts.')
                    //     $("#payment-successful").css('display', 'block');
                    //     $(thisCopy).hide();
                    // }
                }
            }).catch(function (e) {
                $("#card-errors").html(e.responseJSON.message);
                $("#card-errors").css('display', 'block');
                console.log(e);
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
            });
        });

    });

    $(document).on('click', '.button.payment-plan', function(e) {
        e.preventDefault();
        $("#card-errors").html();
        $("#card-errors").css('display', 'none');

        const formValues = $('#payment-form :input');
        var values = {};
        formValues.each(function () {
            if ($(this).attr('type') === 'radio' && !this.checked) {
                return;
            }
            values[this.name] = $(this).val();
        });

        if (!values) {
            $("#card-errors").html('Something went wrong');
            $("#card-errors").css('display', 'block');
            return;
        }
        if (!values['mm_field_email']) {
            $("#card-errors").html('Please fill out all required fields');
            $("#card-errors").css('display', 'block');
            return;
        }

        if (values['creditorpaypal'] === 'credit' || values['creditorpaypal'] === 'applepay') {
            if (!values['mm_field_cc_number'] || !values['mm_field_cc_exp_year'] || !values['mm_field_cc_exp_month'] || !values['mm_field_cc_cvv']) {
                $("#card-errors").html('Please include all card details');
                $("#card-errors").css('display', 'block');
                return;
            }
        }
        $(this).prop('disabled', true);
        $(this).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');


        var thisCopy = this;

        grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
            $.post(accountingcoach.ajax_url + '?action=ac_subscription',
                $('#payment-form').serialize() + '&token=' + token,
            ).then(function (res) {
                if (res.status === 'paypal-redirect') {
                    window.location.replace(res.url);
                } else {
                    let productData = parseSerializedData($('#payment-form').serialize());
                    let productName = productNameMap[productData.product_id]
                    let price;
                    if (productData.product_id == '383') {
                        price = 110;
                    } else if (productData.product_id == '387') {
                        price = 165;
                    } else {
                        price = productData.price;
                    }
                    if (typeof zaraz !== 'undefined' && zaraz.ecommerce) {
                        zaraz.ecommerce('Order Completed', {
                            product_id: productData.product_id,
                            price: price,
                            payment_type: productData.payment_type,
                            name: productName,
                            currency: 'USD',
                        }).then(function () {
                            window.location.href = accountingcoach.site_url + '/purchase-survey/';
                            getUpdatedAchievementPopup();
                        }).catch(function (error) {
                            console.error('E-commerce tracking failed', error);
                            window.location.href = accountingcoach.site_url + '/purchase-survey/';
                            getUpdatedAchievementPopup();
                        });
                    } else {
                        console.error('Zaraz is not defined or ecommerce method is not available');
                        window.location.href = accountingcoach.site_url + '/purchase-survey/';
                        getUpdatedAchievementPopup();
                    }
                }
            }).catch(function (e) {
                $("#card-errors").html(e.responseJSON.message);
                $("#card-errors").css('display', 'block');
                console.log(e);
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
            });

        });
    });

    $('body').on('click','.up-button',function(e){
        e.preventDefault();
        if ($(this).closest('.addusers').length > 0 || $(this).closest('.addteams').length > 0) {
            return;
        }
        var input = $('input[name="account_quantity"]');
        var count = +input.val() + 1;
        if(count < 5)
            return;
        var price = $('input[name="individual_price"]').val();

        input.val(count);
        $('.user-count').html(count);
        $('.user-count-price').html(count * price);
        $('.buy-now.continue-button').attr('data-quantity', count);
        $('.buy-now.continue-button').attr('data-total-price', count * price);
    });
    $('body').on('click','.down-button',function(e){
        e.preventDefault();
        if ($(this).closest('.addusers').length > 0 || $(this).closest('.addteams').length > 0) {
            return;
        }
        var input = $('input[name="account_quantity"]');
        var count = +input.val() - 1;
        if(count < 5)
            return;
        var price = $('input[name="individual_price"]').val();

        input.val(count);
        $('.user-count').html(count);
        $('.user-count-price').html(count * price);
        $('.buy-now.continue-button').attr('data-quantity', count);
        $('.buy-now.continue-button').attr('data-total-price', count * price);
    });

    $('body').on('click', '.addusers .up-button, .addusers .down-button', function (e) {
        e.preventDefault();

        var parentDiv = $(this).closest('.quantity-selector');
        var input = parentDiv.find('input[name="account_quantity"]');
        var individualPrice = parseFloat(parentDiv.find('input[name="individual_price"]').val());
        var count = parseInt(input.val(), 10);

        // Determine if the button clicked is up or down
        if ($(this).hasClass('up-button')) {
            count++;
        } else if ($(this).hasClass('down-button')) {
            count--;
            // Ensure minimum quantities
            if (parentDiv.hasClass('users') && count < 1) count = 1;
            if (parentDiv.hasClass('admins') && count < 1) count = 1; // Minimum 1 for admins
        }

        // Update the input value
        input.val(count);

        // Update the total for the current field
        parentDiv.find('.user-count').html(count);
        var fieldTotal = Math.round(count * individualPrice);
        parentDiv.find('.user-count-price').html(fieldTotal);

        // Update the grand total
        updateGrandTotal();
    });

    function updateGrandTotal() {
        // Get values for admin accounts
        var quantity = parseInt($('input[name="account_quantity"]').val(), 10) || 0;
        var price = parseFloat($('input[name="individual_price"]').val()) || 0;

        // Calculate the grand total
        var grandTotal = Math.round((quantity * price));

        // Update the total display
        $('.addusers .user-count-price').html(grandTotal);
        $('.addusers .buy-now.continue-button').attr('data-total-price', grandTotal);
        $('.addusers .buy-now.continue-button').attr('data-quantity', quantity);
    }

    $('body').on('click', '.addteams .up-button, .addteams .down-button', function (e) {
        e.preventDefault();

        console.log('clicked');

        var parentDiv = $(this).closest('.quantity-select');
        var input = parentDiv.find('input[name="account_quantity"]');
        var individualPrice = parseFloat(parentDiv.find('input[name="individual_price"]').val());
        var count = +input.val(); // Get the current quantity

        // Determine if the button clicked is up or down
        if ($(this).hasClass('up-button')) {
            count++;
        } else if ($(this).hasClass('down-button')) {
            count--;
            // Ensure minimum quantities
            if (parentDiv.hasClass('users') && count < 2) count = 2; // Minimum 2 for regular users
            if (parentDiv.hasClass('admins') && count < 1) count = 1; // Minimum 1 for admins
        }

        // Update the input value
        input.val(count);

        // Update the grand total
        updateGrandTotal2();
    });

    // Function to calculate and update the grand total for .addteams
    function updateGrandTotal2() {
        // Get values for admin accounts
        var adminQuantity = +$('.addteams .quantity-select.admins input[name="account_quantity"]').val();
        var adminPrice = +$('.addteams .quantity-select.admins input[name="individual_price"]').val();

        // Get values for regular user accounts
        var userQuantity = +$('.addteams .quantity-select.users input[name="account_quantity"]').val();
        var userPrice = +$('.addteams .quantity-select.users input[name="individual_price"]').val();

        // Calculate the grand total
        var grandTotal = (adminQuantity * adminPrice) + (userQuantity * userPrice);

        // Update the total display
        $('.addteams .user-count-price').html(grandTotal);
        $('.addteams .buy-now.continue-button').attr('data-total-price', grandTotal);
        // $('.addteams .buy-now.continue-button').attr('data-quantity', adminQuantity + userQuantity);
        $('.addteams .buy-now.continue-button').attr('data-userquantity', userQuantity);
        $('.addteams .buy-now.continue-button').attr('data-adminquantity', adminQuantity);
    }

    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('bulk-success')) {
        document.body.style.overflow = "hidden";
        let overlay = 'bulk-accounts-success';
        let product = $("#multiple-purchase-pro").attr('data-product');
        showPurchaseOverlay(overlay,product, null);
    }

    (function($) {
        var purchaseForm = $('#purchase-reason-form');

        if (!purchaseForm.length) {
            return;
        }

        $('body').css('overflow', 'hidden');

        purchaseForm.submit(function (e) {
            // $(this).find(':submit').prop('disabled', true);
            $('#purchase-reason-form textarea').each(function () {
                if ($(this).val().trim().length === 0) {
                    e.preventDefault();
                    $('.form-error').show();
                    // $(this).find(':submit').prop('disabled', false);
                }
            });
            // if (!$('input[name="purchase_reason[current_situation]"]:checked').val()) {
            //     e.preventDefault();
            //     $('.form-error').show();
            //     $(this).find(':submit').prop('disabled', false);
            // }
            // if (!$('input[name="purchase_reason[interest]"]:checked').val()) {
            //     e.preventDefault();
            //     $('.form-error').show();
            //     $(this).find(':submit').prop('disabled', false);
            // }
            // if (!$('input[name="purchase_reason[skill_level]"]:checked').val()) {
            //     e.preventDefault();
            //     $('.form-error').show();
            //     $(this).find(':submit').prop('disabled', false);
            // }
            // if ($('textarea[name="purchase_reason[current_job]"]').val().trim().length === 0) {
            //     e.preventDefault();
            //     $('.form-error').show();
            //     $(this).find(':submit').prop('disabled', false);
            // }
            // $('#purchase-reason-form radio[name="current_situation"]').each(function () {
            //     if ($(this).val().trim().length === 0) {
            //         e.preventDefault();
            //         $('.form-error').show();
            //     }
            // });
        });

        var currentSlide = 1;
        $('.survey-progress .bar').css('width', ((currentSlide / $('#purchase-reason-form .survey-slide').length) * 100) + '%');
        purchaseForm.on('click', '.next', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('#purchase-reason-form .survey-slide').each(function (index) {
                if (parseInt($(this).attr('data-slide')) === currentSlide) {
                    var completed = true;
                    $(this).find('textarea').each(function () {
                        if ($(this).val().trim().length === 0) {
                            completed = false;
                            $('.form-error').show();
                            return false;
                        }
                    });
                    // if (!$('input[name="purchase_reason[current_situation]"]:checked').val()) {
                    //     completed = false;
                    //     $('.form-error').show();
                    //     return false;
                    // }

                    if (completed) {
                        $('.form-error').hide();
                        $(this).removeClass('active');
                        currentSlide++;
                        $($('#purchase-reason-form .survey-slide')[index + 1]).addClass('active');
                        $('.survey-progress .bar').css('width', ((currentSlide / $('#purchase-reason-form .survey-slide').length) * 100) + '%');
                        return false;
                    }
                }
            });
        });
    })(jQuery);

    function startAmazonPaySession(values) {

        const amazonPayButton = document.querySelector('#AmazonPayButton');
        const submitButton = document.querySelector('a.bulk-purchase, a.purchase');

        if (submitButton) {
            $(submitButton).prop('disabled', true);
            $(submitButton).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');
        }

        if (amazonPayButton && (amazonPayButton.classList.length > 0 || amazonPayButton.children.length > 0)) {
            amazonPayButton.remove();
            const newButton = document.createElement('div');
            newButton.id = 'AmazonPayButton';
            document.body.appendChild(newButton);
        }

        const email = values['mm_field_email'];
        const password = values['mm_field_password'];
        const productId = values['productId'];
        let totalAmount = values['total'];
        const quantity = values['account-quantity'];
        const creditorpaypal = values['creditorpaypal'];
        const conversion = values['conversion'];
        const webinar = values['webinar'];
        let orderType = 'single';
        if (quantity >= 5) {
            orderType = 'bulk';
        }

        const baseURL = `${window.location.protocol}//${window.location.hostname}`;
        let checkoutReviewReturnUrl = `${baseURL}/amazon-pay`;
        let hasParams = false;

        if (conversion) {
            checkoutReviewReturnUrl += `?conversion=${encodeURIComponent(conversion)}`;
            hasParams = true;
        }

        if (webinar) {
            checkoutReviewReturnUrl += hasParams ? `&webinar=${encodeURIComponent(webinar)}` : `?webinar=${encodeURIComponent(webinar)}`;
            hasParams = true;
        }

        if (orderType == 'bulk') {
            checkoutReviewReturnUrl += hasParams ? `&quantity=${encodeURIComponent(quantity)}` : `?quantity=${encodeURIComponent(quantity)}`;
            hasParams = true;
        }

        if (!amazonUpgrade) {
            if (!email || !productId) {
                $("#card-errors").html("Please fill in all required fields.");
                $("#card-errors").css('display', 'block');
                return;
            }
        }

        if (orderType !== 'bulk' && !amazonUpgrade) {
            if (!password) {
                $("#card-errors").html("Please fill in all required fields.");
                $("#card-errors").css('display', 'block');
                return;
            }
        }

        if (orderType == 'bulk') {
            let productPrice = bulkPricingMap[productId];
            totalAmount = productPrice * quantity;
        }

        const customerData = {
            email: email,
            password: password,
            productId: productId,
            quantity: quantity,
            creditorpaypal: creditorpaypal,
            total: totalAmount,
            orderType: orderType,
            student_mm_field_email: values['student_mm_field_email'],
            student_mm_field_school_name: values['student_mm_field_school_name'],
            student_mm_field_school_location: values['student_mm_field_school_location'],
            student_mm_field_school_major: values['student_mm_field_school_major'],
            student_mm_field_school_graduation_date: values['student_mm_field_school_graduation_date'],
            webinar: webinar,
            amazonUpgrade: amazonUpgrade
        };

        fetch('/wp-content/themes/accounting-coach/Theme/AmazonPay/verify-and-process-user.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({customerData: customerData})
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errData => {
                        throw new Error(errData.message || 'Failed to process user');
                        console.log(errData.message);
                    });
                }
                return response.json();
            })
            .then(function (data) {
                if (data.success) {
                    const userId = data.userId;
                    const orderId = data.orderId;

                    if (orderId) {
                        checkoutReviewReturnUrl += hasParams ? `&orderId=${encodeURIComponent(orderId)}` : `?orderId=${encodeURIComponent(orderId)}`;
                    }

                    const payloadJSON = JSON.stringify({
                        webCheckoutDetails: {
                            checkoutReviewReturnUrl: checkoutReviewReturnUrl,
                        },
                        storeId: 'amzn1.application-oa2-client.babff599ec7147de97fbd28d03909b12',
                        paymentDetails: {
                            paymentIntent: 'AuthorizeWithCapture',
                            chargeAmount: {
                                amount: totalAmount,
                                currencyCode: 'USD'
                            },
                        },
                        merchantMetadata: {
                            merchantReferenceId: userId,
                            customInformation: productId
                        }
                    });

                    fetch('/wp-content/themes/accounting-coach/Theme/AmazonPay/generate-signature.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({payloadJSON: payloadJSON})
                    })
                        .then(response => {
                            if (!response.ok) {
                                return response.json().then(errData => {
                                    throw new Error(errData.message || 'Failed to generate signature');
                                });
                            }
                            return response.json();
                        })
                        .then(function (data) {
                            if (data.success) {
                                try {
                                    document.querySelector('#AmazonPayButton').style.display = 'none';
                                    amazon.Pay.renderButton('#AmazonPayButton', {
                                        merchantId: data.merchantId,
                                        publicKeyId: data.publicKeyId,
                                        ledgerCurrency: 'USD',
                                        checkoutLanguage: 'en_US',
                                        productType: 'PayOnly',
                                        placement: 'Checkout',
                                        estimatedOrderAmount: {"amount": totalAmount, "currencyCode": "USD"},
                                        createCheckoutSessionConfig: {
                                            payloadJSON: payloadJSON,
                                            signature: data.signature,
                                            algorithm: 'AMZN-PAY-RSASSA-PSS-V2'
                                        }
                                    });
                                    document.querySelector('#AmazonPayButton').click();
                                } catch (error) {
                                    console.error('Amazon Pay Error:', error);
                                    $("#card-errors").html('Payment failed. Please try again.');
                                    $("#card-errors").css('display', 'block');
                                    if (submitButton) {
                                        $(submitButton).prop('disabled', false);
                                        $(submitButton).html('Submit Order');
                                    }
                                }
                            } else {
                                $("#card-errors").html('Failed to generate signature. Please try again.');
                                $("#card-errors").css('display', 'block');
                                if (submitButton) {
                                    $(submitButton).prop('disabled', false);
                                    $(submitButton).html('Submit Order');
                                }
                            }
                        })
                        .catch(function (error) {
                            console.error('Error:', error);
                            $("#card-errors").html(error.message || 'Payment processing failed. Please try again.');
                            $("#card-errors").css('display', 'block');
                            if (submitButton) {
                                $(submitButton).prop('disabled', false);
                                $(submitButton).html('Submit Order');
                            }
                        });
                } else {
                    $("#card-errors").html('Failed to process user. Please try again.');
                    $("#card-errors").css('display', 'block');
                    if (submitButton) {
                        $(submitButton).prop('disabled', false);
                        $(submitButton).html('Submit Order');
                    }
                }
            })
            .catch(function (error) {
                console.error('Error:', error);
                $("#card-errors").html(error.message || 'Payment processing failed. Please try again.');
                $("#card-errors").css('display', 'block');
                if (submitButton) {
                    $(submitButton).prop('disabled', false);
                    $(submitButton).html('Submit Order');
                }
            });
    }

});

